import { useSelector } from 'react-redux';

const orgJobs = (state: any) => state.orgJobs;
export const useOrgJobs = (): object => useSelector(orgJobs);
